import { prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";

export class IncidentType extends Resource {
    public override type = 'incidentTypes';

    @prop()
    @required()
    public name!: string;

    @prop()
    public source: string = "Worker";

}